import React, { useMemo } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';

import { CashbackStatus, LoadingStatus, useCashbackList } from '@atlas/core';
import { EmptyStateView, Icon, Label, Loader, Pagination } from '@atlas/ui';

import CashBackItem from 'components/ClientProfile/Cashback/CashBackItem';
import ShortFooter from 'components/Footer/ShortFooter';
import { defaultRoutes } from 'components/MainRouter/constants';

const CashbackPage = () => {
  const { activate, content, error, loadingStatus, paging, setPage } = useCashbackList();

  const filteredContent = useMemo(() => {
    if (content.length === 0) return null;

    /**
     * filter cashback by status
     */
    return content
      .filter(
        item =>
          item.status === CashbackStatus.ACTIVE ||
          item.status === CashbackStatus.CREATED ||
          item.status === CashbackStatus.FINISHED,
      )
      .sort((a, b) => {
        const statusOrder = {
          [CashbackStatus.ACTIVE]: 1,
          [CashbackStatus.CREATED]: 2,
          [CashbackStatus.FINISHED]: 3,
        };
        return statusOrder[a.status] - statusOrder[b.status];
      });
  }, [content]);

  return createPortal(
    <div className="profile-wrapper-absolute cashback">
      <Link className="back-to-container" to={defaultRoutes.account}>
        <Icon className="icon-back" name="back" />
        <Label className="title-text" message="cashback" />
      </Link>
      <div className="cashback-wrapper">
        {loadingStatus === LoadingStatus.FAILED && <div>error: {error.message}</div>}
        {loadingStatus === LoadingStatus.SUCCESS && filteredContent && (
          <>
            <div className="cashback-list">
              {filteredContent.map(item => (
                <CashBackItem cashback={item} handleActivate={activate} key={item.id} />
              ))}
            </div>
            <Pagination
              changeCurrentPage={setPage}
              currentPage={paging.currentPage}
              pages={paging.totalPages}
            />
          </>
        )}
        {loadingStatus === LoadingStatus.SUCCESS && !filteredContent && (
          <EmptyStateView
            className="empty-center"
            description="cashback_empty_message"
            title="cashback_empty_title"
          />
        )}
        {loadingStatus === LoadingStatus.LOADING && <Loader />}
        <ShortFooter />
      </div>
    </div>,
    document.body,
  );
};

export default CashbackPage;
